import { EboObject } from '../base-classes/ebo-object';
import { Employee } from '../employee/employee';
import { Division } from './division';

export class DivisionManager extends EboObject {
  employeeID: string;
  employee: Employee;
  divisionID: string;
  division: Division;

  constructor(jsonData: Partial<DivisionManager>) {
    super(jsonData);
    if (jsonData.employee) this.employee = new Employee(jsonData.employee);
    if (jsonData.division) this.division = new Division(jsonData.division);
  }

  toShortString(format: string): string {
    let response: string;
    // console.log(`division Mangers to short string with format ${format}`)
    switch (format) {
      case 'E':
        response = this.employee.toShortString();
        break;
      default:
        response = `${name}: ${this.division.toShortString} - ${this.employee.toShortString()}`;
    }
    return response;
  }
}
